import { render, staticRenderFns } from "./Suche.vue?vue&type=template&id=3e8cd9ae&scoped=true&"
import script from "./Suche.vue?vue&type=script&lang=js&"
export * from "./Suche.vue?vue&type=script&lang=js&"
import style0 from "./Suche.vue?vue&type=style&index=0&id=3e8cd9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8cd9ae",
  null
  
)

export default component.exports